import axios from "axios";
import { Badge, Pane, Spinner, Text } from "evergreen-ui";
import React, { useEffect, useState } from "react";
import { mua } from "./MUA";
import { MDBDataTableV5 } from "mdbreact";
import { CiSettings } from "react-icons/ci";
import StatusDisplay from "./ComponentsStatus/StatusDisplay";
import ManageRegist from "./ComponentsStatus/ManageRegist";
import FileManage from "./ComponentsStatus/FileManage";
import StatusDisplayNew from "./ComponentsStatus/StatusDisplayNew";
import ManageRegistNew from "./ComponentsStatus/ManageRegistNew";
import { academicYearLabel } from "../config/academicYear";

function DataRegister2025() {
  const [DataTable, setDataTable] = useState([]);
  const [Rows, setRows] = useState([]);
  const [LoadPage, setLoadPage] = useState(false);
  const columns = [
    {
      label: "ลำดับ",
      field: "no",
    },
    {
      label: "รอบการสมัคร",
      field: "rob",
    },
    {
      label: "รหัสผู้สมัคร",
      field: "register_id",
    },
    {
      label: "ชื่อ-นามสกุล",
      field: "register_name",
      minimal: "lg",
    },
    {
      label: "ไฟล์เอกสาร",
      field: "files",
      minimal: "sm",
    },
    {
      label: "สถานะ",
      field: "register_status",
      minimal: "lg",
    },
    {
      label: <CiSettings size={23} />,
      field: "manage",
    },
  ];
  const GetListRegister = async () => {
    try {
      setLoadPage(true);
      const fetchregister = await axios.get(
        mua + "/admissionnew2022/showlistregister?id=" + localStorage.getItem("citizent")
      );
      if (fetchregister.status === 200) {
        setLoadPage(false);
        const data = await fetchregister.data.data.data;
        console.log(data);
        if (data.length !== 0) {
          const row = data.map((items, key) =>
            items.ROB_ID !== "xxx" && items.ROB_ID !== "xxx" && items.ROB_ID !== "xxx"
              ? {
                no: key + 1,
                rob: (
                  <div style={{ minWidth: 250 }}>
                    {items.QUOTA_NAME + " " + (items.ROB_NAME !== null ? items.ROB_NAME : "")}
                  </div>
                ),
                register_id: items.REGISTER_ID,
                register_name: items.FULLNAME,
                files: (
                  <Pane>
                    <FileManage
                      REGISTER_SENTVUT_REGISTER={items.REGISTER_SENTVUT_REGISTER}
                      STATUS_DOCUMENT={items.STATUS_DOCUMENT}
                      Major1_LEVEL_OPEN_NAME={items.Major1_LEVEL_OPEN_NAME}
                      ROB_ID={items.ROB_ID}
                    />

                  </Pane>
                ),
                register_status: <StatusDisplayNew data={items} />,
                manage: (
                  <>
                    <ManageRegistNew data={items} />
                
                  </>
                ),
              }
              : {
                no: key + 1,
                rob: (
                  <div style={{ minWidth: 250 }}>
                    {items.QUOTA_NAME + " " + (items.ROB_NAME !== null ? items.ROB_NAME : "")}
                  </div>
                ),
                register_id: items.REGISTER_ID,
                register_name: items.FULLNAME,
                files: (
                  <Pane>
                    <FileManage
                      REGISTER_SENTVUT_REGISTER={items.REGISTER_SENTVUT_REGISTER}
                      STATUS_DOCUMENT={items.STATUS_DOCUMENT}
                      Major1_LEVEL_OPEN_NAME={items.Major1_LEVEL_OPEN_NAME}
                      ROB_ID={items.ROB_ID}
                    />
                  </Pane>
                ),
                register_status: (
                  <Badge fontSize={18} height={"100%"} paddingY={10} color="yellow">
                    รอประกาศรายชื่อผู้ผ่านการคัดเลือก
                  </Badge>
                ),
                manage: <></>,
              }
          );
          setRows(row);
          setDataTable({
            columns: columns,
            rows: row,
          });
        }
      } else {
        setLoadPage(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // window.location.pathname = 'admission'
    GetListRegister();
  }, []);
  return !LoadPage ? (
    <Pane className="container-fluid py-4 ">
      <Text fontWeight={600} fontSize={"clamp(12px,2vw,23px)"} fontFamily="">
        ข้อมูลการสมัครเรียนมหาวิทยาลัยราชภัฏกำแพงเพชร {academicYearLabel()}
      </Text>
      <Pane className="bg-white">
        <MDBDataTableV5
          striped
          className="mt-3  d-none d-md-block"
          theadColor="dark"
          theadTextWhite
          data={DataTable}
          searching={false}
          displayEntries={false}
          sortable={false}
          responsive
        />
        {Rows.length !== 0 && (
          <>
            <Pane className="mt-3  d-block d-md-none ">
              <div className="d-flex flex-column " style={{ gap: 10 }}>
                {Rows.map((i) => (
                  <Pane elevation={4} borderRadius={8} padding={10}>
                    <Pane>
                      <Text fontWeight="600">รอบการสมัคร : </Text>
                      <Text className="text-info">{i.rob}</Text>
                    </Pane>
                    <Pane>
                      <Text fontWeight="600">รหัสผู้สมัคร : </Text>
                      <Text className="text-info">{i.register_id}</Text>
                    </Pane>
                    <Pane>
                      <Text fontWeight="600">ชื่อ-นามสกุล : </Text>
                      <Text className="text-info">{i.register_name}</Text>
                    </Pane>
                    <Pane borderRadius={8} padding={10}>
                      <Text>ไฟล์เอกสาร :</Text>
                      {i.files}
                    </Pane>
                    <Pane
                      display="flex"
                      flexDirection="column"
                      gap={10}
                      marginTop={10}
                    // padding={10}
                    >
                      <Pane>
                        <Text fontWeight="700">สถานะ </Text>
                      </Pane>
                      <Pane>
                        <Text>{i.register_status}</Text>
                      </Pane>
                      {i.manage}
                    </Pane>
                  </Pane>
                ))}
              </div>
            </Pane>
          </>
        )}
      </Pane>
    </Pane>
  ) : (
    <>
      {/* <Overlay isShown={true}> */}
      <Pane display="flex" justifyContent="center" alignItems="center" minHeight={300} width="100%">
        <Spinner color={"red"} size={50} />
      </Pane>
      {/* </Overlay> */}
    </>
  );
}

export default DataRegister2025;
